(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ObjectTestSettingDeleteController',ObjectTestSettingDeleteController);

    ObjectTestSettingDeleteController.$inject = ['$uibModalInstance', 'entity', 'ObjectTestSetting'];

    function ObjectTestSettingDeleteController($uibModalInstance, entity, ObjectTestSetting) {
        var vm = this;

        vm.objectTestSetting = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ObjectTestSetting.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
